import React, { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { Container, Title, VehiclesContainer, PlaceOrderButton, ChooseVehicleLink, StyledSmallText } from './vehicle-list.component.styles'
import { getCountry } from '../../service/country.service'
import { VehicleListHK } from './vehicle-list-hk.component'
import { VehicleListSG } from './vehicle-list-sg.component'
import { VehicleListTW } from './vehicle-list-tw.component'
import { VehicleListVN } from './vehicle-list-vn.component'
import { VehicleListIN } from './vehicle-list-in.component'

const VehicleList = ({ estimations, trackAddressesEstimationsVehicles, quoteInProgress }, ref) => {
  const [t] = useTranslation()
  const country = getCountry()

  const renderCountryVehicles = () => {
    switch (country) {
      case 'IN':
        return <VehicleListIN estimations={estimations} quoteInProgress={quoteInProgress} />
      case 'TW':
        return <VehicleListTW estimations={estimations} quoteInProgress={quoteInProgress} />
      case 'SG':
        return <VehicleListSG estimations={estimations} quoteInProgress={quoteInProgress} />
      case 'VN':
        return <VehicleListVN estimations={estimations} quoteInProgress={quoteInProgress} />
      case 'HK':
      default:
        return <VehicleListHK estimations={estimations} quoteInProgress={quoteInProgress} numberOfVehicles={numberOfVehicles[country]} />
    }
  }

  const numberOfVehicles = {
    HK: 4,
    SG: 6,
    TW: 3,
    VN: 8,
    IN: 6,
  }

  return (
    <Container ref={ref} numberOfVehicles={numberOfVehicles[country]}>
      <Title>{t('text__body__here_are_the_estimated_fees')}</Title>
      <VehiclesContainer numberOfVehicles={numberOfVehicles[country]}>
        {renderCountryVehicles()}
      </VehiclesContainer>

      {country === 'HK' && <StyledSmallText >{t('text__get_quote__estimated_fees_remarks')}</StyledSmallText>}

      <PlaceOrderButton
        href={t('link__place_order')}
        as="a"
        target="_blank"
        onClick={() => trackAddressesEstimationsVehicles('place_order')}
      >
        {t('button__place_order')}
      </PlaceOrderButton>
      <ChooseVehicleLink
        href={t('link__vehicle_type')}
        target="_blank"
        onClick={() => trackAddressesEstimationsVehicles('click_vehicle_faq')}
      >
        {t('text__link__how_to_choose_a_vehicle')}
      </ChooseVehicleLink>
    </Container>
  )
}

VehicleList.propTypes = {
  estimations: PropTypes.object,
  trackAddressesEstimationsVehicles: PropTypes.func.isRequired,
  quoteInProgress: PropTypes.bool,
}

const VehicleListWithRef = forwardRef(VehicleList)

export { VehicleListWithRef }
